const SNIPPET_RADIUS = 24;

export const PRO_LINE_CHARACTER_LIMIT = 400;

function getLineText(line) {
    if (line?.text === 'NULL') return '';
    return String(line?.text || '');
}

function isEmptyTtsLine(text) {
    const normalized = String(text || '').trim();
    return normalized === '' || normalized === 'NULL';
}

function isIndexTTS2Model(modelName) {
    return String(modelName || '').toLowerCase().includes('indextts2');
}

function escapeSnippetWhitespace(text) {
    return text
        .replace(/\r/g, '\\r')
        .replace(/\n/g, '\\n')
        .replace(/\t/g, '\\t');
}

function buildSnippet(text) {
    const chars = Array.from(text);
    const snippetChars = chars.slice(0, SNIPPET_RADIUS * 2);
    const suffix = chars.length > snippetChars.length ? '...' : '';
    return escapeSnippetWhitespace(`${snippetChars.join('')}${suffix}`);
}

function pluralize(count, singular, plural = `${singular}s`) {
    return `${count} ${count === 1 ? singular : plural}`;
}

export function countEditorCharacters(text) {
    return String(text || '').length;
}

export function findLongProLineIssues(lines, modelName, limit = PRO_LINE_CHARACTER_LIMIT) {
    if (!isIndexTTS2Model(modelName)) return [];

    return (Array.isArray(lines) ? lines : []).reduce((issues, line, lineIndex) => {
        const text = getLineText(line);
        if (isEmptyTtsLine(text)) return issues;

        const length = countEditorCharacters(text);
        if (length > limit) {
            issues.push({
                lineIndex,
                length,
                limit,
                overBy: length - limit,
                snippet: buildSnippet(text),
            });
        }
        return issues;
    }, []);
}

export function summarizeLongProLineIssues(issues) {
    if (!Array.isArray(issues) || issues.length === 0) return '';
    const highestLength = Math.max(...issues.map(issue => issue.length));
    const limit = issues[0]?.limit || PRO_LINE_CHARACTER_LIMIT;
    const verb = issues.length === 1 ? 'is' : 'are';
    return `${pluralize(issues.length, 'Pro line')} ${verb} over the recommended ${limit}-character limit. Long Pro lines may generate unstable audio. Longest line: ${highestLength} characters.`;
}

export function formatLongProLineIssueDetail(issue) {
    return `Line ${issue.lineIndex + 1}: ${issue.length} characters (${issue.overBy} over ${issue.limit}) in "${issue.snippet}"`;
}
